import { render, staticRenderFns } from "./businessEndorsement.vue?vue&type=template&id=1e55790a&scoped=true&"
import script from "./businessEndorsement.vue?vue&type=script&lang=js&"
export * from "./businessEndorsement.vue?vue&type=script&lang=js&"
import style0 from "./businessEndorsement.vue?vue&type=style&index=0&id=1e55790a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55790a",
  null
  
)

export default component.exports